import graphqlClient from "../../../apollo";

class UploadProvider {

    uploadFile(file, fileSize) {
        return graphqlClient.mutate({
            mutation: require('./gql/fileUpload.graphql'),
            variables: { file: file, fileSize: fileSize }
        })
    }

    uploadFileAnonymous(file) {
        return graphqlClient.mutate({
            mutation: require('./gql/fileUploadAnonymous.graphql'),
            variables: { file: file }
        })
    }
}

const uploadProvider = new UploadProvider()

export default uploadProvider
